<template>
    <div v-if="is_active_tab" class="search row">
        <div class="col-12">
            <div class="search m-0 pull-right">
                <div class="search-text pull-left">
                    <v-text-field
                        :label="t_search"
                        :value="search"
                        dense
                        clearable
                        hide-details
                        outlined
                        @input="val => l_search = val"
                        style="background-color: white"/>
                </div>
                <div class="ml-4 pull-left">
                    <datepicker
                        :label="t_date_from"
                        :max="to || dateNowUS"
                        :placeholder="from ? undefined : t_placeholder_subOneWeek"
                        :value="from"
                        hideDetails
                        @input="val => l_from = val"
                    />
                </div>
                <div class="ml-4 pull-left">
                    <datepicker
                        :label="t_date_to"
                        :max="dateNowUS"
                        :min="from"
                        :placeholder="to ? undefined : t_placeholder_now"
                        :value="to"
                        hideDetails
                        @input="val => l_to = val"
                    />
                </div>

                <div class="search-group no-padding pull-left">
                    <div class="m-l-sm m-b-0">
                        <chosen-multiselect id="select-groups" :trans-placeholder-multi="t_groups" v-model="l_groups" style="margin-bottom:-15px;">
                            <option v-for="optiondata in fullGroupList.data"
                                    :value="optiondata.id">{{optiondata.name}}</option>
                        </chosen-multiselect>
                    </div>
                </div>

                <div class="search-location no-padding pull-left">
                    <div class="m-l-sm m-b-0">
                        <chosen-multiselect id="select-locations" :trans-placeholder-multi="t_locations" v-model="l_locations">
                            <option v-for="optiondata in fullLocationList.data"
                                    :value="optiondata.id">{{optiondata.name}}</option>
                        </chosen-multiselect>
                    </div>
                </div>

                <div class="pull-right">
                    <span v-bind:data-balloon="!action_visibility ? t_column + ' / ' + t_filter : null"
                    data-balloon-pos="left"
                    data-balloon-length="medium">
                        <v-btn aria-label="open more options" type="button" class="btn btn-secondary m-l-sm" @click.stop.prevent="toggleActions">
                            {{t_options_button}}
                            <i :class="['fa-regular m-l-sm', action_visibility ? 'fa-caret-up' : 'fa-caret-down']"></i>
                        </v-btn>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import debounce from 'debounce';
    import toaster from "../common/toaster";
    import fixAriaTag from "./searchBarWorkaround";
    import TextField from "../common/text-field.vue";
    import {dateISOToDateUS, dateTodayUS, dateUSToDateISO, localizeDate} from "../../../utils/date";

    export default {
        components: {TextField},
        props: [
            'from',
            'to',
            'filter_from',
            'filter_to',
            'search',
            'groups',
            'locations',
            'action_visibility'
        ],
        data: function () {
            return {
                t_search: Lang.langGet("Search"),
                t_groups: Lang.langChoice('Screengroup|Screengroups', 2),
                t_date_from: Lang.langGet("Show data from"),
                t_date_to: Lang.langGet("Show data until"),
                t_load_groups_failed: Lang.langGet('Failed to load screengroups.'),
                t_locations: Lang.langChoice('Location|Locations', 2),
                t_load_locations_failed: Lang.langGet('Locations could not be loaded.'),
                t_column: Lang.langGet("Column Preset"),
                t_filter: Lang.langGet("Filter"),
                t_deprecated_options: Lang.langGet('More Options'),
                t_hide_deprecated_options: Lang.langGet('Less Options'),
                t_options_button: '',

                l_from: this.from,
                l_to: this.to,
                l_search: this.search,
                l_groups: this.groups,
                l_locations: this.locations,
                is_active_tab: false,

                fullGroupList: {
                    data: []
                },
                fullLocationList: {
                    data: []
                },
            }
        },
        computed: {
            dateNowUS() {
                return dateTodayUS()
            },
            t_placeholder_now() {
                return localizeDate((this.filter_to != '')?this.filter_to:this.dateNowUS, Laravel.activeDateformat)
            },
            t_placeholder_subOneWeek() {
                const toDate = this.to ? new Date(dateUSToDateISO(this.to)) : new Date()
                const subOneWeekDate = new Date(toDate)
                subOneWeekDate.setDate(subOneWeekDate.getDate() - 7)
                return localizeDate((this.filter_from != '')?this.filter_from:dateISOToDateUS(subOneWeekDate.toISOString().substring(0, 10)), Laravel.activeDateformat)
            }
        },
        watch: {
            l_from: debounce(function () {
                this.$emit('update:from', this.l_from);
                EaseEventBus.fire('triggerUpdateTable');
            }, 500),
            l_to: debounce(function () {
                this.$emit('update:to', this.l_to);
                EaseEventBus.fire('triggerUpdateTable');
            }, 500),
            l_search: debounce(function () {
                this.$emit('update:search', this.l_search);
                EaseEventBus.fire('triggerUpdateTable');
            }, 500),
            l_groups: function () {
                this.$emit('update:groups', this.l_groups);
                EaseEventBus.fire('triggerUpdateTable');
            },
            l_locations: function () {
                this.$emit('update:locations', this.l_locations);
                EaseEventBus.fire('triggerUpdateTable');
            },
        },
        methods: {
            loadGroups: function () {
                if (this.fullGroupList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadscreengroups', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullGroupList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_groups_failed);
                });
            },
            loadLocations: function () {
                if (this.fullLocationList.data.length > 0) {
                    return;
                }

                axios.post('/administration/project/loadlocations', {
                    project_id: Laravel.activeProject
                }).then((response) => {
                    this.fullLocationList.data = response.data.data;
                }).catch((error) => {
                    if (error.response.status === 401) {
                        window.location = '/login';
                    }
                    toaster.error(this.t_load_locations_failed);
                });
            },
            toggleActions: function() {
                this.t_options_button = !this.action_visibility ? this.t_hide_deprecated_options : this.t_deprecated_options;
                this.$emit('update:action_visibility', !this.action_visibility);
            }
        },
        mounted() {
            $(this.$el).appendTo('.system-reporting .ibox-heading');

            let $div = $("#reporting-list");
            let observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.attributeName === "class") {
                        let attributeValue = $(mutation.target).prop(mutation.attributeName);
                        this.is_active_tab = attributeValue.indexOf('active') !== -1;
                    }
                });
            });
            observer.observe($div[0], {
                attributes: true
            });

            this.loadGroups();
            this.loadLocations();

            fixAriaTag($(this.$el));
            this.t_options_button = this.action_visibility ? this.t_hide_deprecated_options : this.t_deprecated_options;

            EaseEventBus.listen('FilterOrPresetWasSetReports', () => {
                this.t_options_button = this.t_hide_deprecated_options;
            });
        }
    }
</script>

<style scoped>
    .inline-block {
        padding-right: 10pt;
    }

    .search .search-text {
        width: 250px;
    }
    .search .search-group {
        width: 350px;
    }
    .search .search-location {
        width: 350px;
    }

</style>
